import { useId, useState } from 'react';

import { Menu, MenuItem } from '@mui/material';

import { IconButton } from '@components/button';
import { RESOURCE_LINKS } from '@assets/constants';
import { useCan } from '@assets/helpers/hooks';
import { InternetIcon } from '@assets/icons';

export const ResourcesMenu = () => {
  const id = useId();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);
  const { can } = useCan();

  // The permission controls the globe button itself, not just its menu contents.
  if (!can('dev_resourses', 'read')) {
    return null;
  }

  const resources = RESOURCE_LINKS.filter(({ guard }) => !guard || can(guard.entity, guard.action));

  return (
    <>
      <IconButton
        id={`${id}-button`}
        aria-label="Resources"
        aria-controls={isOpen ? `${id}-menu` : undefined}
        aria-haspopup="menu"
        aria-expanded={isOpen ? 'true' : undefined}
        active={isOpen}
        isBoxShadowDisabled
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <InternetIcon />
      </IconButton>
      <Menu
        id={`${id}-menu`}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          list: { 'aria-labelledby': `${id}-button` },
          paper: {
            sx: {
              mt: 2,
              borderRadius: (theme) => theme.spacing(4),
              bgcolor: 'white_100',
              color: 'dark',
            },
          },
        }}
      >
        {resources.map(({ label, link }) => (
          <MenuItem
            key={label}
            component="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setAnchorEl(null)}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
